const normalize = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')

const TYPE_MATCHERS = [
  { idtypecontact: 1, match: (f) => f.includes('chef') && f.includes('rayon') },
  { idtypecontact: 2, match: (f) => f.includes('compta') },
  { idtypecontact: 3, match: (f) => f.includes('direct') },
  { idtypecontact: 4, match: (f) => f.includes('pdg') || f.includes('adherent') },
  { idtypecontact: 5, match: (f) => f.includes('informatique') },
  { idtypecontact: 6, match: (f) => f.includes('qualite') },
  { idtypecontact: 7, match: (f) => f.includes('formation') },
]

export function matchTypeContact (fonction) {
  const normalized = normalize(fonction)
  if (!normalized || /^ex\b/.test(normalized)) return null
  const matcher = TYPE_MATCHERS.find(({ match }) => match(normalized))
  return matcher ? matcher.idtypecontact : null
}

export function normalizePhone (raw) {
  let digits = String(raw || '').replace(/\D/g, '')
  if (digits.startsWith('0033')) digits = `0${digits.slice(4)}`
  else if (digits.startsWith('33') && digits.length === 11) digits = `0${digits.slice(2)}`
  return digits.length === 10 ? digits : ''
}

export function splitNotionName (notionContact) {
  const prenom = String(notionContact.firstName || '').trim()
  const nom = String(notionContact.lastName || '').trim()
  if (nom || prenom) return { nom, prenom }
  const parts = String(notionContact.fullName || '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return { nom: '', prenom: '' }
  return { nom: parts[0], prenom: parts.slice(1).join(' ') }
}
